import Vue from 'vue';
import scraperApi from '../services/scraperApi';

const state = {
    countries: [],
    kaoshiCountries: [],
};

const getters = {
    countries: ({ countries }) => countries,
    kaoshiCountries: ({ kaoshiCountries }) => kaoshiCountries,
};

const mutations = {
    SET_COUNTRIES(state, payload) {
        state.countries = payload;
    },
    SET_KAOSHI_COUNTRIES(state, payload) {
        state.kaoshiCountries = payload;
    },
};

const actions = {
    async loadCountries({ commit }) {
        try {
            const { data } = await scraperApi.countries();
            commit('SET_COUNTRIES', data);
        } catch (error) {
            console.error(error);
        }
    },
    async loadKaoshiCountries({ commit }) {
        try {
            const { data } = await Vue.backendApi()
                .countries()
                .list();
            commit('SET_KAOSHI_COUNTRIES', data);
        } catch (error) {
            console.error(error);
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
